import { render, staticRenderFns } from "./BusinessLookupCard.vue?vue&type=template&id=fbd86540&scoped=true&"
import script from "./BusinessLookupCard.vue?vue&type=script&lang=js&"
export * from "./BusinessLookupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd86540",
  null
  
)

export default component.exports